import { Outlet, useLocation, useNavigate } from "react-router-dom";

function NavigateBtn({ children, path }) {
    // navigation button
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const currentPath = pathname === `/accounting/${path}`;

    function navigateHandler() {
        navigate(path);
    }

    return (
        <button
            className="font-semibold py-3 duration-200"
            onClick={navigateHandler}
            style={{
                color: currentPath ? "var(--red)" : "",
                borderBottom: currentPath ? "2px solid var(--red)" : "",
            }}
        >
            {children}
        </button>
    );
}

export default function Finance() {

    return (
        <div className="w-full">
            <h1>ACCOUNTING</h1>
            <div className="border-b-2">
                <NavigateBtn path="fee-co">Fee CO</NavigateBtn>
            </div>
            <Outlet />
        </div>
    );
}
